import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
    <g fill="none" fillRule="evenodd" stroke="#000" strokeWidth="2">
      <path d="M10.25 0L10.25 20M20 10.25L0 10.25" transform="rotate(45 5.214 21.554)" />
    </g>
  </svg>
);
